// extracted by mini-css-extract-plugin
module.exports = {"gwMediaSidebarWrapper":"MediaSideBar_gwMediaSidebarWrapper__-tjML","player":"MediaSideBar_player__CLFuh"};